import { render } from "./pos-designation.vue?vue&type=template&id=77bcafa2"
import script from "./pos-designation.vue?vue&type=script&lang=js"
export * from "./pos-designation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__